
//http://s-yadav.github.io/react-number-format/

import React from "react";
import { NumericFormat } from "react-number-format";

export type NumberFormatCustomProps = {
    name: string,
    value: number,
    decimals?: number,
    format?: string,
    onChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>,
    children?: React.ReactNode;
};

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props: NumberFormatCustomProps, ref) {
    const {
        decimals,
        format,
        onChange,
        ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                if (values.floatValue !== props.value) {
                    onChange({
                        target: {
                            name: props.name,
                            //value: values.value.trim().length > 0 ? +values.value : undefined,
                            value: values.value.trim().length > 0 ? +values.value : null,
                            //value: values.value,
                        },
                        //} as React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>);
                    } as any);
                }
            }}
            //thousandSeparator
            valueIsNumericString={true}
            decimalScale={decimals}
            //format={format}
            //allowEmptyFormatting={format ? true : undefined}
        //prefix="$"
        />
    );
});


export default NumberFormatCustom;